<bfd-loading [fullScreen]="loading" [show]="loading"></bfd-loading>
<fibra-toast-error-message [color]="typToastColor"></fibra-toast-error-message>
<bfd-generic-modal
  *ngIf="showError"
  [title]="'Desculpe, mas tivemos um erro!'"
  [message]="
    'Tivemos um erro inesperados e não conseguimos acessa a página solicitada. Tente novamente, e caso o erro continue volte mais tarde.'
  "
  (tryEventEmmitter)="tryRequest($event)"
></bfd-generic-modal>
<bfd-popover
  [content]="balanceSingle"
  [visible]="popoverService.shouldLoad"
  [view]="typeView"
  (dataEmitter)="downloadReceipt($event)"
></bfd-popover>
<app-period-filter
  [title]="'Detalhe das movimentações'"
  [scheduling]="true"
  (rangeChange)="handleRange($event)"
></app-period-filter>
<div class="table-content">
  <bfd-container-display-message
    *ngIf="scheduleObj?.length === 0"
    [content]="contentEmptyData"
  ></bfd-container-display-message>
  <bfd-transaction-table
    *ngIf="scheduleObj?.length > 0"
    [tableOrigin]="'extract-scheduling'"
    [data]="scheduleObj"
    [showSaldo]="false"
    (dataEmitter)="getInfBalance($event)"
  ></bfd-transaction-table>
</div>
